export const OPEN_AI_API
  = 'https://api.openai.com/v1/engines/text-curie-001/completions';
